import React from 'react';
import { Platform } from 'react-native';
import { useIsAdhaJourney } from '@/core/hooks';
import HomeScreenWeb from './HomeScreen';
import HomeScreenMobile from './HomeScreenMobile';
import HomeScreenMobileAdhaMobile from './HomeScreenMobileAdhaMobile';
import VentureScreen from './VentureScreen';

export function HomeScreen() {
    const isAdhaJourney = useIsAdhaJourney();
    if (Platform.OS === 'web') {
        return <HomeScreenWeb />;
    }
    return isAdhaJourney ? <HomeScreenMobileAdhaMobile /> : <HomeScreenMobile />;
}

export { HomeScreenMobile, HomeScreenMobileAdhaMobile, VentureScreen };
